import { render, staticRenderFns } from "./SpetsSignal1220.vue?vue&type=template&id=514e8aa0"
import script from "./SpetsSignal1220.vue?vue&type=script&lang=js"
export * from "./SpetsSignal1220.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports